(function () {
	function initModalSync(modal) {
		var match = modal.id.match(/^ProductModal-(.+)$/);
		if (!match) return;
		var sectionId = match[1];
		var variantPicker = document.getElementById('variant-radios-' + sectionId);
		if (!variantPicker) return;

		var syncedVariantId = null;
		var originalShow = modal.show.bind(modal);

		modal.show = function (opener) {
			var currentVariant = variantPicker.currentVariant;
			var url = variantPicker.dataset.url;

			if (!currentVariant || !url || currentVariant.id === syncedVariantId) {
				originalShow(opener);
				return;
			}

			fetch(url + '?variant=' + currentVariant.id + '&section_id=' + sectionId)
				.then(function (response) {
					return response.text();
				})
				.then(function (responseText) {
					var html = new DOMParser().parseFromString(responseText, 'text/html');
					var freshModal = html.getElementById(modal.id);
					var freshWrapper = freshModal && freshModal.querySelector('.swiper-wrapper');
					var liveWrapper = modal.querySelector('.swiper-wrapper');
					if (freshWrapper && liveWrapper) {
						liveWrapper.innerHTML = freshWrapper.innerHTML;
					}
					syncedVariantId = currentVariant.id;
				})
				.catch(function () {})
				.finally(function () {
					originalShow(opener);
				});
		};
	}

	// The zoom modal is rendered once at page load with whichever variant's
	// media matched the alt-text/variant filtering at that time. Switching
	// variants afterwards only refreshes the visible thumbnail gallery (see
	// VariantSelects.renderProductInfo in global.js) - the modal itself is
	// never touched, so it keeps showing whatever variant was selected when
	// the page first rendered. This re-fetches the section HTML (same source
	// VariantSelects already uses) right before the modal opens whenever the
	// selected variant has changed, so the zoomed image always matches what's
	// currently on screen.
	if (window.customElements) {
		customElements.whenDefined('product-modal').then(function () {
			document.querySelectorAll('product-modal').forEach(function (modal) {
				if (modal.id.indexOf('ProductModal-') === 0) {
					initModalSync(modal);
				}
			});
		});
	}
})();
